function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M26.9 1.29999H4.19999C3.99999 1.29999 3.79999 1.49999 3.79999 1.69999V27C3.79999 27.2 3.99999 27.4 4.19999 27.4H7.09999V27.5V28.8C7.09999 29.3 7.49999 29.7 7.99999 29.7H10.4C10.9 29.7 11.3 29.3 11.3 28.8V27.5V27.4H19.6V27.5V28.8C19.6 29.3 20 29.7 20.5 29.7H22.9C23.4 29.7 23.8 29.3 23.8 28.8V27.5V27.4H26.8C27.1 27.4 27.3 27.2 27.3 26.9V1.69999C27.3 1.49999 27.1 1.29999 26.9 1.29999ZM10.5 28.8H7.99999V27.5H10.5V28.8ZM22.9 28.8H20.5V27.5H22.9V28.8ZM26.4 2.19999V7.19999H4.59999V2.19999H26.4ZM4.59999 26.5V7.59999H26.4V26.5H4.59999Z",
  fill: "#1C33C8"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.5 10.3C11.7 10.3 8.59998 13.4 8.59998 17.2C8.59998 21 11.7 24.1 15.5 24.1C19.3 24.1 22.4 21 22.4 17.2C22.4 13.4 19.3 10.3 15.5 10.3ZM15.5 23.7C11.9 23.7 8.99998 20.8 8.99998 17.2C8.99998 13.6 12 10.7 15.5 10.7C19.1 10.7 22 13.6 22 17.2C22 20.8 19.1 23.7 15.5 23.7Z",
  fill: "#1C33C8"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.5 12.2C12.9 12.2 10.7 14.3 10.6 16.9C10.5 16.9 10.4 17 10.4 17.1C10.4 17.2 10.5 17.4 10.6 17.4C10.8 20 12.9 22 15.5 22C18.2 22 20.4 19.8 20.4 17.1C20.4 14.4 18.2 12.2 15.5 12.2ZM15.5 12.7C17.8 12.7 19.6 14.4 19.9 16.6C19.8 16.6 19.8 16.6 19.7 16.7C19.2 17.1 18.8 17.4 18.2 17.7C17.9 17.8 17.5 18 17.2 17.9C16.9 17.8 16.7 17.6 16.4 17.4C16.3 17.4 16.2 17.3 16.1 17.2C15.2 16.6 14 16.5 13 17C12.9 17.1 12.8 17.2 12.7 17.2C12.4 17.4 12.1 17.5 11.8 17.5C11.7 17.4 11.5 17.3 11.3 17.2C11.2 17.2 11.2 17.1 11.1 17.1C11.1 14.7 13.1 12.7 15.5 12.7ZM15.5 21.5C13.3 21.5 11.4 19.8 11.2 17.6C11.4 17.7 11.6 17.9 11.8 17.9C12.3 17.9 12.6 17.7 13 17.5C13.1 17.4 13.2 17.3 13.3 17.3C14.2 16.9 15.2 16.9 16 17.5C16.1 17.5 16.2 17.6 16.3 17.7C16.6 17.9 16.9 18.1 17.3 18.2C17.4 18.2 17.5 18.2 17.6 18.2C18 18.2 18.3 18 18.4 18.1C19 17.8 19.4 17.5 19.9 17.1C19.9 19.5 17.9 21.5 15.5 21.5Z",
  fill: "#1C33C8"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M20.2 5.89999H24.8C24.9 5.89999 25 5.79999 25 5.69999V3.49999C25 3.39999 24.9 3.29999 24.8 3.29999H20.2C20.1 3.29999 20 3.39999 20 3.49999V5.69999C20 5.79999 20.1 5.89999 20.2 5.89999ZM20.4 3.69999H24.6V5.39999H20.4V3.69999Z",
  fill: "#1C33C8"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.89998 5.99999C7.69998 5.99999 8.19998 5.29999 8.19998 4.59999C8.19998 3.89999 7.59998 3.29999 6.89998 3.29999C6.19998 3.29999 5.59998 3.79999 5.59998 4.59999C5.59998 5.39999 6.19998 5.99999 6.89998 5.99999ZM6.89998 3.69999C7.39998 3.69999 7.79998 4.09999 7.79998 4.59999C7.79998 5.09999 7.39998 5.49999 6.89998 5.49999C6.39998 5.49999 5.99998 5.09999 5.99998 4.59999C5.99998 4.09999 6.39998 3.69999 6.89998 3.69999Z",
  fill: "#1C33C8"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.5 5.99999C11.2 5.99999 11.7 5.29999 11.7 4.59999C11.7 3.89999 11.1 3.29999 10.4 3.29999C9.69997 3.29999 9.09998 3.79999 9.09998 4.59999C9.09998 5.39999 9.69998 5.99999 10.5 5.99999ZM10.5 3.69999C11 3.69999 11.4 4.09999 11.4 4.59999C11.4 5.09999 11 5.49999 10.5 5.49999C9.99998 5.49999 9.59998 5.09999 9.59998 4.59999C9.59998 4.09999 9.99998 3.69999 10.5 3.69999Z",
  fill: "#1C33C8"
});

var SvgWaschmaschine = function SvgWaschmaschine(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWaschmaschine, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/waschmaschine.70dfbf35.svg";
export { ForwardRef as ReactComponent };